var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-input',{ref:"custom_input",attrs:{"value":_vm.displayValue,"type":_vm.type,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"readonly":_vm.readonly,"clearable":""},on:{"input":_vm.handleInput,"change":_vm.handleInputChange,"blur":_vm.handleBlur,"focus":_vm.handleFocus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }